(function(_){
    'use strict';
    _['ESHOP.KEY'] = 'Loja';
    _['ESHOP.NO-CONTENT'] = 'Não há conteúdo neste módulo';
    _['ESHOP.NO-PRODUCTS'] = 'Não há nenhum produto com o filtro atual';
    _['PRODUCTS.PRODUCT.TOCART.CONFIRM'] = 'Adicionar ao carrinho';
}(translations['pt']));












// WEBPACK FOOTER //
// ./src/app/modules/eshop/lang/eshop-lang_pt.js